module.exports = __webpack_public_path__ + "img/BFG.50e9386d.svg";